import React from 'react'
import { Card } from 'antd'
import { SprintSpecLogo } from '../Logo/SprintSpecLogo'
import { Typography } from 'antd'

const { Text } = Typography

interface Props {
  children: React.ReactNode
}

export const AuthCard: React.FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <div className="text-center mb-8">
          <SprintSpecLogo />
        </div>
        {children}
      </Card>
      <div className="text-center mt-8">
        <Text type="secondary" className="text-xs">
          This site is protected by reCAPTCHA and the Google Terms of Service
          and Privacy Policy apply.
        </Text>
      </div>
    </div>
  )
}
